import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';

interface BPReqData {
  productCode: string;
  subtotal?: number;
}

interface ProductConfig {
  transaction_category_id: string;
}

interface PaymentMethod {
  balance?: number;
  amplitudeAccountName?: string;
}
export function logAccountChange(
  employeeId: string,
  tcid: string,
  pCode: string,
  source: string,
  bpReqData: BPReqData,
  item: PaymentMethod,
  validatedReferralCode: string,
): void {
  const e = AMPLITUDE_CONSTANTS.BillPayment.transactionSummary.pickPaymentMethod;
  const { attributes, name } = e;

  AmplitudeHelper.logEvent(name, {
    [attributes.employee_id]: employeeId,
    [attributes.transaction_category_id]: tcid,
    [attributes.product_code]: pCode,
    [attributes.source]: source,
    [attributes.point_used]: bpReqData?.subtotal,
    [attributes.point_balance]: item?.balance,
    [attributes.referral_code]: validatedReferralCode,
    [attributes.payment_method]: item?.amplitudeAccountName,
  });
}

export function logDropDownPressed(
  source: string,
  employeeId: string,
  productConfig: ProductConfig,
  bpReqData: BPReqData,
  validatedReferralCode: string,
): void {
  const e = AMPLITUDE_CONSTANTS.BillPayment.transactionSummary.paymentMethod;
  const { attributes } = e;

  AmplitudeHelper.logEvent(e.name, {
    [attributes.source]: source,
    [attributes.employee_id]: employeeId,
    [attributes.transaction_category_id]: productConfig.transaction_category_id,
    [attributes.product_code]: bpReqData.productCode,
    [attributes.referral_code]: validatedReferralCode,
  });
}
